import { render, staticRenderFns } from "./doctor_congrats_1.vue?vue&type=template&id=54af48f1&scoped=true&"
import script from "./doctor_congrats_1.vue?vue&type=script&lang=js&"
export * from "./doctor_congrats_1.vue?vue&type=script&lang=js&"
import style0 from "./doctor_congrats_1.vue?vue&type=style&index=0&id=54af48f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54af48f1",
  null
  
)

export default component.exports